import { render } from "./Terms.vue?vue&type=template&id=2ae84d94&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=2ae84d94&lang=scss&module=s"
cssModules["s"] = style0
import "./Terms.vue?vue&type=style&index=1&id=2ae84d94&lang=scss&scoped=true"
import "./Terms.vue?vue&type=style&index=2&id=2ae84d94&lang=scss"

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-2ae84d94"]])

export default __exports__